import * as Sentry from '@sentry/react';

import { camelcaseKeysDeep } from '../../utils/camelCaseDeep';

export const responseInterceptor = () => (action, response) => {
  if (response.error && response.status >= 500) {
    Sentry.captureException(`API Error: ${action.method} ${action.endpoint}`, scope => {
      scope.setTransactionName(window.location.href);

      const contextData = {
        request: {
          method: action.method,
          endpoint: action.endpoint,
        },

        response: {
          status: response.status,
          payload: response.payload,
        },
      };

      if (contextData.request.body) {
        contextData.request.body = action.body;
      }

      scope.setContext('API Request', contextData.request);
      scope.setContext('API Response', contextData.response);
    });
  }

  return {
    ...response,
    payload: camelcaseKeysDeep(response.payload),
  };
};
